import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Layout from '@src/components/layout/Layout';
import { useCallback, useEffect, useState } from 'react';
import Add from './components/Add';
import ProductionCompanyDTO from '@src/adapters/dto/productionCompany/ProductionCompanyDTO';
import useFindProductionCompaniesLazy from '@src/adapters/hooks/productionCompany/useFindProductionCompanies';

const PREFIX = 'Template';

const classes = {
  pageTitle: `${PREFIX}-pageTitle`,
  paper: `${PREFIX}-information`,
};

const StyledTitle = styled(Box)(({ theme }) => ({
  padding: '0 20px 20px 20px',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
}));

function ProductionCompanies() {
  const [companies, setCompanies] = useState<ProductionCompanyDTO[]>([]);
  const [open, setOpen] = useState(false);
  const { execute: find } = useFindProductionCompaniesLazy();
  const [recordCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selectedPage, setSelectedPage] = useState(0);

  const findCompanies = useCallback(() => {
    find({
      pageSize: rowsPerPage,
      currentPage: selectedPage,
    }).then((result) => {
      setCompanies(result.productionCompanies);
    });
  }, [find, rowsPerPage, selectedPage]);

  useEffect(() => {
    findCompanies();
  }, [findCompanies]);

  useEffect(() => {}, []);

  const handleNewClick = () => {
    setOpen(true);
  };

  const handleClose = (productionCompany: ProductionCompanyDTO) => {
    setCompanies((prev) => [...prev, productionCompany]);
    setOpen(false);
  };

  const handleRowClick = (
    event: React.MouseEvent<unknown>,
    production: ProductionCompanyDTO
  ) => {};

  return (
    <Layout>
      <StyledTitle>
        <Typography variant="h4">Production Companies</Typography>
        <Button
          onClick={handleNewClick}
          color="secondary"
          variant="contained"
          size="medium">
          New Company
        </Button>
      </StyledTitle>
      <Paper elevation={8} className={classes.paper}>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size="small"
            aria-label="Contents table">
            <TableHead>
              <TableRow>
                <TableCell component="th" key="variant" align="left">
                  Company Name
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {companies.map((company, index) => {
                return (
                  <TableRow
                    hover
                    onClick={(event) => handleRowClick(event, company)}
                    role="checkbox"
                    tabIndex={-1}
                    key={index}>
                    <TableCell scope="row">{company.name}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={recordCount}
          rowsPerPage={rowsPerPage}
          page={selectedPage}
          onPageChange={(event, number) => setSelectedPage(number)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setSelectedPage(0);
          }}
        /> */}
      </Paper>
      <Add open={open} close={handleClose} />
    </Layout>
  );
}

export default ProductionCompanies;
